// Gmail Integration Configuration
// Centralized configuration for Gmail OAuth and API settings

import { getOAuthRedirectUri } from '@/utils/config';

export const gmailConfig = {
  // OAuth Configuration
  oauth: {
    clientId: import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID,
    redirectUri: import.meta.env.VITE_GOOGLE_OAUTH_REDIRECT_URI || getOAuthRedirectUri(),
    scopes: (import.meta.env.VITE_GOOGLE_OAUTH_SCOPES || '').split(',').filter(Boolean),
    responseType: 'code'
  },

  // API Configuration
  api: {
    rateLimit: parseInt(import.meta.env.VITE_GMAIL_API_RATE_LIMIT) || 100,
    batchSize: parseInt(import.meta.env.VITE_EMAIL_BATCH_SIZE) || 50,
    timeout: parseInt(import.meta.env.VITE_WEBHOOK_TIMEOUT) || 30000
  },

  // Debug Configuration
  debug: {
    enabled: import.meta.env.VITE_DEBUG_GMAIL_INTEGRATION === 'true',
    logLevel: import.meta.env.VITE_DEBUG_GMAIL_INTEGRATION === 'true' ? 'debug' : 'error'
  },

  // Validation
  validate() {
    const errors = [];

    if (!this.oauth.clientId) {
      errors.push('Google OAuth Client ID is required');
    }

    if (!this.oauth.redirectUri) {
      errors.push('Google OAuth Redirect URI is required');
    }

    if (this.oauth.scopes.length === 0) {
      errors.push('Google OAuth Scopes are required');
    }

    if (errors.length > 0) {
      throw new Error(`Gmail configuration errors: ${errors.join(', ')}`);
    }

    return true;
  },

  // Get configuration status
  getStatus() {
    return {
      oauth: {
        clientId: !!this.oauth.clientId,
        redirectUri: !!this.oauth.redirectUri,
        scopes: this.oauth.scopes.length
      },
      api: {
        rateLimit: this.api.rateLimit,
        batchSize: this.api.batchSize,
        timeout: this.api.timeout
      },
      debug: {
        enabled: this.debug.enabled
      }
    };
  }
};

export default gmailConfig;
